const sectionTypes = {
  CONTENT:                        'content',
  FORM:                           'form',
  FORM_SCREENDESIGNER_OVERWRITES: 'screenDesignerOverwrites',
  POST_FORM_CONTENT:              'post-form-content',
};

export default sectionTypes;
